import axios from 'axios'
import { apiUrl } from '../../env.json'
import { LOGIN_USER, LOGOUT_USER } from './modules/user/types'

export const actions = {
  tryLogin (store, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${apiUrl}auth/login`, payload)
      .then(response => {
        localStorage.setItem('daUser', JSON.stringify({'token': response.data.token}))
        store.commit(LOGIN_USER, response.data)
        resolve(response)
      })
      .catch(error => reject(error))
    })
  },
  logout (store, payload) {
    localStorage.removeItem('daUser')
    localStorage.removeItem('vuex')
    store.commit('CLEAR_MODULES')
    store.commit(LOGOUT_USER)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js